import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const SignedIncompleteStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();

  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} color={'var(--mantine-color-grape-7)'} onClick={() => onClick('SENT_TO_BANK')} loading={isLoading}>
          {t('credit.status.action.SENT_TO_BANK')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => onClick('CANCELED')} loading={isLoading}>
          {t('credit.status.action.CANCELED')}
        </Button>
      </Box>
    </>
  )
}

export default SignedIncompleteStatusActions;